import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FaEdit, FaTrashAlt } from 'react-icons/fa';
import { getBaseUrl } from "../global/Globalapi";
const BranchMasterForm = () => {
  const [formData, setFormData] = useState({
    branch_name: '',
    branch_des: '',
    latitude: '',
    longitude: '',
    region_id: '',
    addr1: '',
    addr2: '',
    addr3: '',
    addr4: '',
    address: '',
    branch_alies: ''
  });

  const [regions, setRegions] = useState([]);
  const [branches, setBranches] = useState([]);
  const [editId, setEditId] = useState(null);
  const [message, setMessage] = useState({ type: '', text: '' });
  const [loading, setLoading] = useState(false);

  // Backend URL on port 5000
  // const API_BASE_URL = 'http://localhost:5000';
const API_BASE_URL = getBaseUrl();
  // Fetch regions and branches on component mount
  useEffect(() => {
    fetchRegions();
    fetchBranches();
  }, []);

  const fetchRegions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/regionmaster`);
      setRegions(response.data);
    } catch (error) {
      console.error('Error fetching regions:', error);
    }
  };

  const fetchBranches = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/branchmaster`);
      setBranches(response.data);
    } catch (error) {
      console.error('Error fetching branches:', error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage({ type: '', text: '' });
    
    try {
      if (editId) {
        // Update existing branch
        await axios.put(`${API_BASE_URL}/api/branchmaster/${editId}`, formData, {
          headers: { 'Content-Type': 'application/json' },
          timeout: 10000
        });
        setMessage({ type: 'success', text: 'Branch updated successfully!' });
      } else {
        // Create new branch
        await axios.post(`${API_BASE_URL}/api/branchmaster`, formData, {
          headers: { 'Content-Type': 'application/json' },
          timeout: 10000
        });
        setMessage({ type: 'success', text: 'Branch saved successfully!' });
      }
      handleReset();
      fetchBranches(); // Refresh the list
    } catch (error) {
      console.error('Error details:', error);
      const errorMsg = error.response?.data?.message || 'Error saving branch';
      setMessage({ type: 'error', text: errorMsg });
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (branch) => {
    setEditId(branch.branch_id);
    setFormData({
      branch_name: branch.branch_name || '',
      branch_des: branch.branch_des || '',
      latitude: branch.latitude || '',
      longitude: branch.longitude || '',
      region_id: branch.region_id || '',
      addr1: branch.addr1 || '',
      addr2: branch.addr2 || '',
      addr3: branch.addr3 || '',
      addr4: branch.addr4 || '',
      address: branch.address || '',
      branch_alies: branch.branch_alies || ''
    });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleDelete = async (branchId) => {
    if (!window.confirm('Are you sure you want to delete this branch?')) return;
    
    try {
      await axios.delete(`${API_BASE_URL}/api/branchmaster/${branchId}`);
      setMessage({ type: 'success', text: 'Branch deleted successfully!' });
      fetchBranches();
    } catch (error) {
      console.error('Error deleting branch:', error);
      const errorMsg = error.response?.data?.message || 'Error deleting branch';
      setMessage({ type: 'error', text: errorMsg });
    }
  };

  const handleReset = () => {
    setEditId(null);
    setFormData({
      branch_name: '',
      branch_des: '',
      latitude: '',
      longitude: '',
      region_id: '',
      addr1: '',
      addr2: '',
      addr3: '',
      addr4: '',
      address: '',
      branch_alies: ''
    });
  };

  // Helper to get region name by ID
  const getRegionName = (regionId) => {
    const region = regions.find(r => r.region_id === regionId);
    return region ? region.region_name : '-';
  };

  const inputStyle = {
    width: '100%',
    padding: '10px',
    margin: '10px 0',
    border: '1px solid #ddd',
    borderRadius: '4px',
    fontSize: '16px'
  };

  const labelStyle = {
    fontWeight: 'bold',
    display: 'block',
    marginBottom: '5px'
  };

  return (
    <div style={{ maxWidth: '1000px', margin: '50px auto', padding: '20px' }}>
      {/* Form Section */}
      <div style={{
        padding: '30px',
        border: '1px solid #ddd',
        borderRadius: '8px',
        backgroundColor: '#f9f9f9',
        marginBottom: '30px'
      }}>
        <h2 style={{ textAlign: 'center', marginBottom: '30px', color: '#333', borderBottom: '2px solid #4CAF50', paddingBottom: '10px' }}>
          {editId ? 'Edit Branch' : 'Add Branch'}
        </h2>
      
        {message.text && (
          <div style={{
            padding: '10px',
            marginBottom: '20px',
            borderRadius: '4px',
            backgroundColor: message.type === 'success' ? '#d4edda' : '#f8d7da',
            color: message.type === 'success' ? '#155724' : '#721c24'
          }}>
          {message.text}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div>
          <label style={labelStyle}>Branch Name *</label>
          <input
            type="text"
            name="branch_name"
            value={formData.branch_name}
            onChange={handleChange}
            style={inputStyle}
            placeholder="Enter branch name"
            required
            maxLength="100"
          />
        </div>

        <div>
          <label style={labelStyle}>Branch Description *</label>
          <textarea
            name="branch_des"
            value={formData.branch_des}
            onChange={handleChange}
            style={{ ...inputStyle, minHeight: '100px' }}
            placeholder="Enter branch description"
            required
          />
        </div>

        <div>
          <label style={labelStyle}>Branch Alias *</label>
          <input
            type="text"
            name="branch_alies"
            value={formData.branch_alies}
            onChange={handleChange}
            style={inputStyle}
            placeholder="Enter branch alias"
            required
            maxLength="15"
          />
        </div>

        <div>
          <label style={labelStyle}>Region *</label>
          <select
            name="region_id"
            value={formData.region_id}
            onChange={handleChange}
            style={inputStyle}
            required
          >
            <option value="">Select Region</option>
            {regions.map(region => (
              <option key={region.region_id} value={region.region_id}>
                {region.region_name}
              </option>
            ))}
          </select>
        </div>

        <h3 style={{ marginTop: '20px', color: '#666' }}>Address Information</h3>
        
        <div>
          <label style={labelStyle}>Address Line 1</label>
          <input
            type="text"
            name="addr1"
            value={formData.addr1}
            onChange={handleChange}
            style={inputStyle}
            placeholder="Enter address line 1"
            maxLength="50"
          />
        </div>

        <div>
          <label style={labelStyle}>Address Line 2</label>
          <input
            type="text"
            name="addr2"
            value={formData.addr2}
            onChange={handleChange}
            style={inputStyle}
            placeholder="Enter address line 2"
            maxLength="100"
          />
        </div>

        <div>
          <label style={labelStyle}>Address Line 3</label>
          <input
            type="text"
            name="addr3"
            value={formData.addr3}
            onChange={handleChange}
            style={inputStyle}
            placeholder="Enter address line 3"
            maxLength="100"
          />
        </div>

        <div>
          <label style={labelStyle}>Address Line 4</label>
          <input
            type="text"
            name="addr4"
            value={formData.addr4}
            onChange={handleChange}
            style={inputStyle}
            placeholder="Enter address line 4"
            maxLength="100"
          />
        </div>

        <div>
          <label style={labelStyle}>Full Address</label>
          <textarea
            name="address"
            value={formData.address}
            onChange={handleChange}
            style={{ ...inputStyle, minHeight: '80px' }}
            placeholder="Enter complete address"
          />
        </div>

        <h3 style={{ marginTop: '20px', color: '#666' }}>Location Coordinates</h3>
        
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
          <div>
            <label style={labelStyle}>Latitude</label>
            <input
              type="text"
              name="latitude"
              value={formData.latitude}
              onChange={handleChange}
              style={inputStyle}
              placeholder="Enter latitude"
              maxLength="200"
            />
          </div>

          <div>
            <label style={labelStyle}>Longitude</label>
            <input
              type="text"
              name="longitude"
              value={formData.longitude}
              onChange={handleChange}
              style={inputStyle}
              placeholder="Enter longitude"
              maxLength="200"
            />
          </div>
        </div>

        <div style={{ marginTop: '30px', textAlign: 'center' }}>
          <button type="submit" disabled={loading} style={{
            backgroundColor: loading ? '#ccc' : '#4CAF50',
            color: 'white',
            padding: '12px 24px',
            border: 'none',
            borderRadius: '4px',
            cursor: loading ? 'not-allowed' : 'pointer',
            fontSize: '16px',
            marginRight: '10px'
          }}>
            {loading ? 'Saving...' : (editId ? 'Update Branch' : 'Save Branch')}
          </button>
          <button 
            type="button" 
            style={{
              backgroundColor: '#f44336',
              color: 'white',
              padding: '12px 24px',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '16px'
            }}
            onClick={handleReset}
          >
            {editId ? 'Cancel' : 'Reset'}
          </button>
        </div>
        </form>
      </div>

      {/* Branch List Section */}
      <div style={{
        padding: '30px',
        border: '1px solid #ddd',
        borderRadius: '8px',
        backgroundColor: '#fff',
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
      }}>
        <h3 style={{ 
          marginBottom: '20px', 
          color: '#333',
          borderBottom: '2px solid #2196F3',
          paddingBottom: '10px'
        }}>
          Branch 
        </h3>

        {branches.length === 0 ? (
          <p style={{ textAlign: 'center', color: '#666' }}>No branches found.</p>
        ) : (
          <div style={{ overflowX: 'auto' }}>
            <table style={{ 
              width: '100%', 
              borderCollapse: 'collapse',
              fontSize: '14px'
            }}>
              <thead>
                <tr style={{ backgroundColor: '#b91c1c', color: 'white' }}>
                  <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #ddd' }}>S.No</th>
                  <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #ddd' }}>Branch Name</th>
                  <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #ddd' }}>Alias</th>
                  <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #ddd' }}>Region</th>
                  <th style={{ padding: '12px', textAlign: 'left', borderBottom: '2px solid #ddd' }}>Address</th>
                  <th style={{ padding: '12px', textAlign: 'center', borderBottom: '2px solid #ddd' }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {branches.map((branch, index) => (
                  <tr key={branch.branch_id} style={{ 
                    backgroundColor: index % 2 === 0 ? '#f9f9f9' : '#fff',
                    borderBottom: '1px solid #ddd'
                  }}>
                    <td style={{ padding: '12px' }}>{index + 1}</td>
                    <td style={{ padding: '12px' }}>{branch.branch_name}</td>
                    <td style={{ padding: '12px' }}>{branch.branch_alies}</td>
                    <td style={{ padding: '12px' }}>{getRegionName(branch.region_id)}</td>
                    <td style={{ padding: '12px' }}>{branch.address || branch.addr1 || '-'}</td>
                    <td style={{ padding: '12px', textAlign: 'center' }}>
                      <div style={{ display: 'flex', justifyContent: 'center', gap: '8px' }}>
                        <button
                          onClick={() => handleEdit(branch)}
                          style={{
                            backgroundColor: '#2196F3',
                            color: 'white',
                            border: 'none',
                            padding: '8px 12px',
                            borderRadius: '4px',
                            cursor: 'pointer'
                          }}
                          title="Edit Branch"
                        >
                          <FaEdit />
                        </button>
                        <button
                          onClick={() => handleDelete(branch.branch_id)}
                          style={{
                            backgroundColor: '#f44336',
                            color: 'white',
                            border: 'none',
                            padding: '8px 12px',
                            borderRadius: '4px',
                            cursor: 'pointer'
                          }}
                          title="Delete Branch"
                        >
                          <FaTrashAlt />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default BranchMasterForm;